// components/Modals/AttendanceDetailsModal.js
import React from 'react';

const AttendanceDetailsModal = ({ data, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Детальний перегляд відвідування</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>Дата:</strong> {new Date(data.date).toLocaleDateString('uk-UA')}
              </div>
              <div className="col-md-6">
                <strong>Статус:</strong> {data.status}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>Години:</strong> {data.hours}
              </div>
              <div className="col-md-6">
                <strong>Примітки:</strong> {data.notes || 'Немає приміток'}
              </div>
            </div>
            {data.details && (
              <div className="attendance-details">
                <h6>Детальна інформація:</h6>
                <pre className="bg-light p-3 rounded">
                  {JSON.stringify(data.details, null, 2)}
                </pre>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Закрити
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceDetailsModal;